import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loading = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this.loading.asObservable();

  constructor() {
  }

  show(request): void {
    this.loading.next(true);
  }

  hide(request): void {
    this.loading.next(false);
  }
}
